/**
 * CMS 관리 (/adm/cms) — 페이앱 CMS 자동이체 결과 업로드·이력·신규 회원 등록
 * ($j.Pages.Admin.Cms / body data-page-name="Cms")
 *
 * 버튼은 data-cms="함수명" 위임으로 부른다 — window 에 함수를 내놓지 않는다.
 * 모달 3개(업로드·상세·신규등록)는 blade 의 <script type="text/template"> 를 JBModal 로 띄운다.
 */
export default class Cms {
    initialize() { initialize(); }
}

let $table = null;
let selectedResultNum = 0;


/**
 * 엑셀 업로드 모달 열기
 */
function openUploadModal(){
    $j.Ui.JBModal.html('cms-upload-modal', $('#cmsUploadModalTpl').html(), 'CMS 엑셀 업로드', {width: '500px'});
}

/**
 * 신규 등록 모달 열기
 */
function openNewCmsModal(){
    $j.Ui.JBModal.html('cms-new-modal', $('#cmsNewModalTpl').html(), '신규 CMS 회원 등록하기', {width: '560px'});
}

function initialize() {
    loadCmsHistoryTable();

    // 버튼 — data-cms="함수명" (상세보기는 data-n 에 로그번호). 모달이 매번 새로 그려지므로 위임
    const CLICK = {
        openUploadModal, openNewCmsModal, showCMSlist, searchMem, newmemberch, regnewCmsmember, downloadDetailExcel,
        showCmsDetail: (el) => showCmsDetail(Number(el.dataset.n)),
        hideDetailWrap: () => $('#cms-detail-wrap').hide(),
    };
    $(document).on('click', '[data-cms]', function (e) {
        const fn = CLICK[this.dataset.cms];
        if (!fn) return;
        if (this.tagName === 'A') e.preventDefault();
        fn(this);
    });
    // 회원 검색 결과(서버가 그리는 행) — 고르면 그 번호로 검사까지
    $(document).on('click', '#searchRst .cms-new-search-row', function () { usenumbermember(Number(this.dataset.num)); });

    bindUpload();
}

// 엑셀 업로드 시 동작 (모달이 매번 새로 그려지므로 위임 이벤트 사용)
function bindUpload() {
$(document).on('submit', '#uploadForm', function(e) {
    e.preventDefault();

    const $form = $(this);
    const $submitBtn = $form.find('button[type="submit"]');
    const formData = new FormData(this);

    $submitBtn.prop('disabled', true).text('업로드 중...');

    $.ajax({
        url: '/adm/ajax/cms/save',
        type: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        success: function(response) {
            if (response.result === 'success') {
                $j.Ui.Toast.show('success', `${response.message} 건 저장 완료`);
                $j.Ui.JBModal.close('cms-upload-modal');
            } else {
                $j.Ui.Toast.show('error', response.message || '업로드 실패');
            }

            $submitBtn.prop('disabled', false).text('엑셀 업로드');
            loadCmsHistoryTable();
        },
        error: function(err) {
            $j.Ui.Toast.show('error', '업로드 중 오류가 발생했습니다');
            console.error(err);
            $submitBtn.prop('disabled', false).text('엑셀 업로드');
        }
    });
});

// 검색 인풋 엔터 키 (위임 이벤트)
$(document).on('keypress', '#searchstring', function(e){
    if (e.which === 13) { searchMem(); e.preventDefault(); }
});
}


/**
 * cms log table
 */
function loadCmsHistoryTable() {
    if ($table) {
        $table.destroy();
        $('#cms-history-table').empty();  // 테이블 내용을 비워서 초기화
    }

    const columns = [
        {data: 'created_at', title: '처리 날짜', render: v => $j.Common.Util.formatDateTime(v)},
        {
            data: 'round_month',
            title: '처리 회차',
            render: function (data) {
                if (!data) return '';
                return dayjs(data).format('YYYY년 M월');
            }
        },
        {data: 'success', title: '입력 성공'},
        {data: 'fail', title: '입력 실패'},
        {
            data: null,
            title: '상세보기',
            orderable: false,
            render: function (data, type, row) {
                return `<button class='btn btn-sm btn-primary' data-cms='showCmsDetail' data-n='${row.num}'>상세보기</button>`;
            }
        }
    ];

    $table = new DataTable('#cms-history-table', {
        destroy: true,
        autoWidth: false,
        columns: columns,
        ajax: {
            url: '/adm/ajax/cms/get',
            type: 'POST',
        },
        language: {
            emptyTable: "데이터가 없습니다.",
            lengthMenu: "_MENU_ 개씩 보기",
            info: "",
            infoEmpty: "",
            loadingRecords: "로딩 중...",
            zeroRecords: "일치하는 결과가 없습니다.",
            paginate: {
                previous: "<",
                next: ">"
            }
        },
        serverSide: true,
        pageLength: 10,
        searching: false,
        lengthChange: false,
        ordering: false
    });

}

/**
 * 상세 보기 시 해당 월 member cms table (JBModal + 클라이언트 사이드 검색)
 * @param runNum cms log num
 */
function showCmsDetail(runNum) {
    selectedResultNum = runNum;

    $j.Ui.JBModal.html('cms-detail-modal', $('#cmsDetailModalTpl').html(), '상세 내역', {
        width: '850px',
        onOpen: function() {
            const detailTable = new DataTable('#cmsDetailTable', {
                autoWidth: false,
                rowCallback: formatRow,
                dom: '<"cms-detail-toolbar"f<"cms-detail-actions">>rt<"cms-detail-footer"ip>',
                initComplete: function() {
                    $('#cms-detail-modal .cms-detail-actions').html(
                        '<button type="button" class="btn btn-success btn-sm" data-cms="downloadDetailExcel">엑셀 다운로드</button>'
                    );
                },
                ajax: {
                    url: '/adm/ajax/cms/detail',
                    type: 'POST',
                    data: { num: runNum }
                },
                columns: [
                    { data: 'num', title: 'no' },
                    // 회원 표기는 관리자 공용 규약 — `이름#번호` + 회원 팝오버
                    { data: null, title: '회원',
                        render: (d, t, r) => $j.F.Admin.Member.Pop.cell(r.mb_no, r.mem_name) },
                    { data: 'cms_num', title: 'CMS 번호' },
                    { data: 'amount', title: '입금액' },
                    {
                        data: 'round_month',
                        title: '회차',
                        render: function (data) {
                            if (!data) return '';
                            return dayjs(data).format('YYYY년 M월');
                        }
                    },
                    {
                        data: 'is_withdrawn',
                        title: '상태',
                        render: (val) => parseInt(val, 10) === 1 ? '출금성공' : '출금실패'
                    }
                ],
                language: {
                    emptyTable: "데이터가 없습니다.",
                    lengthMenu: "_MENU_ 개씩 보기",
                    search: "검색:",
                    searchPlaceholder: "이름, 회원번호, CMS 번호…",
                    info: "_TOTAL_ 건 중 _START_ ~ _END_",
                    infoEmpty: "0 건",
                    infoFiltered: "(전체 _MAX_ 건에서 검색)",
                    loadingRecords: "불러오는 중...",
                    zeroRecords: "일치하는 결과가 없습니다.",
                    paginate: { previous: "<", next: ">" }
                },
                serverSide: false,
                pageLength: 10,
                searching: true,
                lengthChange: false,
                ordering: true
            });

            // 회원칸은 회원 팝오버가 연다(캐시내역도 그 메뉴에 있다) — 칸 클릭을 따로 걸면 팝오버가 막힌다
        }
    });
}

function downloadExcel() {
    const table = $('#cmsDetailTable').DataTable();
    const data = table.data();

    // Create CSV content
    let csv = 'no,회원번호,이름,CMS 번호,입금액,회차,상태\n';

    data.each(function (row) {
        const roundMonth = row.round_month ? dayjs(row.round_month).format('YYYY년 M월') : '';
        const status = row.is_withdrawn === 1 ? '출금성공' : '출금실패';
        csv += `${row.num},${row.mb_no},${row.mem_name},${row.cms_num},${row.amount},${roundMonth},${status}\n`;
    });

    // Create download link
    const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', 'cms_detail.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

function formatRow(row, data) {

    const refundPoint = Number(data.amount).toLocaleString();

    // 두 번째 셀 (회원) — 파랑·굵게 (sass .cms-td-member)
    $(row).find('td:eq(1)').addClass('cms-td-member');

    // 입금액 칸(네 번째, eq(3)) — 금액 포맷 + 오른쪽·굵게 (sass .cms-td-amount).
    // 칸 순서: no · 회원 · CMS 번호 · 입금액 · 회차 · 상태
    $(row).find('td:eq(3)').addClass('cms-td-amount').text(refundPoint);
}
/**
 * 신규회원 중복검사
 */
function newmemberch(){
    let unum = parseInt($('#newcmsmembernum').val(), 10);
    if (isNaN(unum)) unum = 0;
    if (unum < 1) { $j.Ui.Toast.show('error', '숫자만 입력해 주세요'); return; }

    $.ajax({
        type: "POST",
        url: "/adm/ajax/cms/members/info",
        dataType: "json",
        data: {usernum: unum},
        success: function(data){
            if (data.result == true) {
                let n = parseInt(data.memno, 10);
                if (isNaN(n)) n = 0;
                if (n < 1) { $j.Ui.Toast.show('error', '회원 번호가 잘못된 번호 입니다'); return; }
                const cms_num = data.cms_num;
                if (cms_num.length > 4) {
                    $('#useroknum').val(0);
                    $j.Ui.Toast.show('error', '이미 CMS번호가 부여된 회원 입니다');
                    return;
                }
                $('#useroknum').val(data.memno);
                $('#mem_name').val(data.memname);
                $('#mem_hp').val(data.mem_hp);
                $j.Ui.Toast.show('success', `${data.memname} 님 확인 완료`);
            } else {
                $j.Ui.Toast.show('error', '없는 회원 입니다');
            }
        }
    });
}


/**
 *  신규 회원 등록
 */
function regnewCmsmember(){
    let unum = parseInt($('#useroknum').val(), 10);
    const mem_cmscode = $('#mem_cmscode').val().trim();
    if (isNaN(unum)) unum = 0;
    if (unum < 1) { $j.Ui.Toast.show('error', '회원 번호 검사를 먼저 실행해 주세요'); return; }
    if (mem_cmscode.length < 6) { $j.Ui.Toast.show('error', 'CMS 코드를 10자리로 입력해 주세요'); return; }
    if (mem_cmscode.length != 10) { if (!confirm("CMS 코드가 10자리가 아닙니다.\n\n계속할까요?")) return; }

    $.ajax({
        type: "POST",
        url: "/adm/ajax/cms/members/register",
        dataType: "json",
        data: {usernum: unum, cmscode: mem_cmscode},
        success: function(data){
            if (data.result == true) {
                $('#useroknum').val("0");
                $('#mem_name').val("");
                $('#mem_hp').val("");
                $j.Ui.Toast.show('success', '등록되었습니다');
                $j.Ui.JBModal.close('cms-new-modal');
            } else {
                const mg = (data.reson || '등록 실패').trim();
                $j.Ui.Toast.show('error', mg);
            }
        }
    });
}

/**
 * 회원 검색
 */
function searchMem(){
    const str = $('#searchstring').val();
    if (str.length < 2) { $j.Ui.Toast.show('error', '최소 2자 이상 입력해 주세요'); return; }

    $.ajax({
        type: "POST",
        url: "/adm/ajax/cms/members/search",
        data: {searchstring: str},
        success: function(data){
            $('#searchRst').show().html(data);
        }
    });
}

/**
 * 회원 선택 적용
 * @param num
 */
function usenumbermember(num){
    $('#searchRst').hide();
    $('#newcmsmembernum').val(num);
    newmemberch();
}

/**
 * cms 회원 리스트
 */
function showCMSlist(){
    $j.Ui.JBModal.open('jb-modal-cms-members', '/adm/cms/members', null, {title: 'CMS 회원 리스트', width: '720px', onOpen: () => $j.F.Admin.CmsMembers.init()});
}

function downloadDetailExcel(){
    location.href=`/excel/cms/detail?num=${selectedResultNum}`;
}
